import { useEffect, useState } from "react";

/**
 * Lightweight FingerprintJS visitor ID loader.
 * Uses the free "pro lite" CDN bundle — no yarn package needed.
 * Returns the visitor ID string once available (or null if disabled).
 */
export default function useFingerprint() {
  const [visitorId, setVisitorId] = useState(null);
  const apiKey = process.env.REACT_APP_FINGERPRINTJS_API_KEY;

  useEffect(() => {
    if (!apiKey) return;
    let cancelled = false;
    (async () => {
      try {
        const { load } = await import(
          /* webpackIgnore: true */
          `https://fpjscdn.net/v3/${apiKey}`
        );
        const fp = await load();
        const result = await fp.get();
        if (!cancelled) setVisitorId(result.visitorId);
      } catch (e) {
        // Silently degrade - FP is optional
        if (!cancelled) setVisitorId(null);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [apiKey]);

  return visitorId;
}
